<!--https://element.eleme.cn/#/zh-CN/component/menu-->
<template>
  <div class="sellerMenu">
    <el-menu class="menu" background-color="#fff" text-color="#333" active-text-color="#ff0023" :unique-opened="true" :collapse-transition="false">
      <template v-for="(menu, index) in menuList">
        <el-submenu :index="`${index}`" v-if="menu.children && menu.children.length > 0" :key="index" class="menu_item_more">
          <template slot="title">
            <a>
              <i :class="`iconfont ${menu.icon}`"></i>
              <span>{{ menu.name }}</span>
            </a>
          </template>
          <el-menu-item :index="`${index}-${childIndex}`" v-for="(child, childIndex) in menu.children" :key="`${index}-${childIndex}`">
            <template slot="title">
              <a :href="`${child.url}`" :target="child.target">
                <span>{{ child.name }}</span>
              </a>
            </template>
          </el-menu-item>
        </el-submenu>
        <el-menu-item :index="`${index}`" :key="index" v-else class="menu_item">
          <template slot="title">
            <a :href="`${menu.url}`" :target="menu.target">
              <i :class="`iconfont ${menu.icon}`"></i>
              <span>{{ menu.name }}</span>
            </a>
          </template>
        </el-menu-item>
      </template>
    </el-menu>
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      menuList: [],
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  mounted() {
    this.mjMenu();
  },
  methods: {
    mjMenu() {
      this.$store.dispatch("header/mjMenu", {}).then((data) => {
        this.menuList = data || {};
      });
    },
  },
};
</script>
